import {axiosInstance} from "../instance";

const EmulsionReportPerUser = () => {
    return axiosInstance
        .get('/api/emulsion-reports-per-user');
}

const EmulsionReport = (emulsionReport) => {
    return axiosInstance
        .post('/api/emulsion-report', emulsionReport);
}

const EmulsionReportById = (emulsionReportId) => {
    return axiosInstance
        .get(`/api/emulsion-report/${emulsionReportId}`);
}

const EmulsionReportListAdmin = (filterData) => {
    return axiosInstance
        .post('/api/emulsion-report-search', filterData);
}

const EmulsionReportsQuantity = (data) => {
    return axiosInstance
        .post('/api/emulsion-reports/quantity', data);
}

const EmulsionReportsDelete = (emulsionReportId) => {
    return axiosInstance.delete(`/api/emulsion-reports/${emulsionReportId}`);
};

const EmulsionReportsContractors = () => {
    return axiosInstance
        .get('/api/emulsion-reports-contractors');
}

const EmulsionReportsPlateNumbers = () => {
    return axiosInstance
        .get('/api/emulsion-reports-plate-numbers');
}


const EmulsionReportsCarrierNames = () => {
    return axiosInstance
        .get('/api/emulsion-reports-carrier-names');
}


const EmulsionReportsDrivers = () => {
    return axiosInstance
        .get('/api/emulsion-reports-drivers');
}

const EmulsionReportAddingStatus = () => {
    return axiosInstance.get('/api/emulsion-reports/adding-posibility');
};

const SendEmulsionReportConfirmation = (reportId, attachment) => {
    return axiosInstance.post(`/api/emulsion-reports/send-confirmation/${reportId}`, attachment, {headers: {'Content-Type': 'multipart/form-data'}})
}

const ChangeEmulsionReportConfirmationStatus = (data) => {
    return axiosInstance.post('/api/emulsion-reports-confirmation-status', data);
}


export {
    EmulsionReportPerUser,
    EmulsionReportsQuantity,
    EmulsionReportListAdmin,
    EmulsionReport,
    EmulsionReportById,
    EmulsionReportsDelete,
    EmulsionReportsContractors,
    EmulsionReportsPlateNumbers,
    EmulsionReportsCarrierNames,
    EmulsionReportsDrivers,
    EmulsionReportAddingStatus,
    SendEmulsionReportConfirmation,
    ChangeEmulsionReportConfirmationStatus
}
